/* eslint-disable */
export default {
  Inbound: 'Inkomend',
  Outbound: 'Uitgaand',
  log: 'Lijst',
  save: 'Opslaan en nieuw',
  discard: 'Weggooien en nieuw',
  hangup: 'Ophangen',
  reject: 'Naar voicemail',
  saveDraftAndCreateNewLog: 'Concept opslaan en nieuwe oproeplijst maken',
} as const;

// @key: @#@"Inbound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"Outbound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save and new"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard and new"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hangup"@#@
// @key: @#@"reject"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"saveDraftAndCreateNewLog"@#@ @source: @#@"Save draft and create new call log"@#@
